import type { EvaluationResultsErrorResponse, TranscriptContent } from "../api/evaluations/types";
import { TrainingSessionChallengeResultStatus } from "../types";

function isTrainingSessionChallengeResultStatus(value: unknown): value is TrainingSessionChallengeResultStatus {
    return (Object.values(TrainingSessionChallengeResultStatus) as unknown[]).includes(value);
}

export function isEvaluationTranscriptContent(
    data: TranscriptContent | EvaluationResultsErrorResponse,
): data is TranscriptContent {
    return Object.keys(data).includes("EvaluationDetails");
}

export function getChallengeResults(status?: string): TrainingSessionChallengeResultStatus {
    const maybe = status?.toLocaleLowerCase();
    if (isTrainingSessionChallengeResultStatus(maybe)) return maybe;

    return TrainingSessionChallengeResultStatus.NOT_AVAILABLE;
}

export function isValidHttpUrl(text: string) {
    try {
        const url = new URL(text);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch {
        return false;
    }
}
